export interface User {
    email: string;
    name: string;
    roles: string[]
    sub: string;
    crm?: string;
    phone?: string;
}

export enum RolesEnum {
    ARIEL_ADMIN = 'ARIEL_ADMIN',
    ARIEL_DOCTOR = 'ARIEL_DOCTOR'
}

export const PROFILES = {
    ARIEL_ADMIN: [RolesEnum.ARIEL_ADMIN, RolesEnum.ARIEL_DOCTOR],
    ARIEL_DOCTOR: [RolesEnum.ARIEL_DOCTOR],
}